import {AddCircleOutline, RemoveCircleOutline} from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

import {Alert, ListItemIcon} from './styles'

export type Props = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  usersToAdd: string[]
  usersToRemove: string[]
  isFullImport: boolean
  handleSubmit: () => void
  isSubmitting: boolean
}

const View = ({
  open,
  setOpen,
  usersToAdd,
  usersToRemove,
  isFullImport,
  handleSubmit,
  isSubmitting,
}: Props) => {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Confirm members addition/removal</DialogTitle>
      <DialogContent>
        {isFullImport && (
          <Alert severity="warning">
            You are about to do a full import, meaning that all of the current
            members will be removed and only the members that you input on the
            previous screen will be added. If this is not what you want, click
            "Cancel" and select "Only ADD new users" before retrying.
          </Alert>
        )}
        <DialogContentText>
          Please confirm the members that are being added and removed below
          before proceeding. Once you click "Confirm", the changes will be
          applied.
        </DialogContentText>
        <Box mt={3}>
          <Typography fontWeight="bold" color="secondary">
            Added members
            {usersToAdd.length ? ` (${usersToAdd.length})` : null}:
          </Typography>
          <List>
            {usersToAdd.length === 0 ? (
              <ListItem key="group-members-update-dialog-empty-added">
                <ListItemText primary="None." />
              </ListItem>
            ) : (
              usersToAdd.map(user => (
                <ListItem key={user}>
                  <ListItemIcon>
                    <AddCircleOutline fontSize="small" color="success" />
                  </ListItemIcon>
                  <ListItemText primary={user} />
                </ListItem>
              ))
            )}
          </List>
          <Typography fontWeight="bold" color="secondary">
            Removed members
            {usersToRemove.length ? ` (${usersToRemove.length})` : null}:
          </Typography>
          <List>
            {usersToRemove.length === 0 ? (
              <ListItem key="group-members-update-dialog-empty-removed">
                <ListItemText primary="None." />
              </ListItem>
            ) : (
              usersToRemove.map(user => (
                <ListItem key={user}>
                  <ListItemIcon>
                    <RemoveCircleOutline fontSize="small" color="error" />
                  </ListItemIcon>
                  <ListItemText primary={user} />
                </ListItem>
              ))
            )}
          </List>
        </Box>
        <DialogActions>
          <Button
            color="secondary"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            Confirm
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default View
